<template>
  <DxPopup
    :visible="!!store.current"
    :title="store.current?.title ?? ''"
    :width="popupWidth"
    :height="popupHeight"
    :max-height="popupMaxHeight"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :wrapper-attr="{ class: 'app-confirm-dialog-wrapper' }"
    @update:visible="onVisibleChange"
  >
    <div class="app-confirm-dialog__text">
      {{ store.current?.message }}
    </div>
    <div class="app-confirm-dialog__actions">
      <DxButton
        :text="store.current?.cancelText ?? t('confirm.cancel')"
        type="normal"
        styling-mode="outlined"
        @click="store.cancel"
      />
      <DxButton
        :text="store.current?.okText ?? t('confirm.confirm')"
        :type="dxOkType"
        styling-mode="contained"
        @click="store.confirm"
      />
    </div>
  </DxPopup>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { DxPopup } from "devextreme-vue";
import DxButton from "devextreme-vue/button";

import { useConfirmDialog } from "../store/useConfirmDialog";
import { useResponsivePopup } from "../common/composables/useResponsivePopup";

const { t } = useI18n();
const store = useConfirmDialog();
const { popupWidth, popupHeight, popupMaxHeight } = useResponsivePopup(440, "auto");

const dxOkType = computed<"default" | "danger" | "success">(() => {
  const okType = store.current?.okType;
  if (okType === "danger") return "danger";
  if (okType === "success") return "success";
  return "default";
});

function onVisibleChange(value: boolean) {
  // Закрытие крестиком / outside-click — трактуем как «отмена».
  if (!value) store.cancel();
}
</script>
